module.exports = __webpack_public_path__ + "img/ryabina-credit.2fdc0e0b.svg";